import React from 'react';

export default function BranchPreview({ tableProps }) {
  return (
    <>
      {
        Object.entries(tableProps).map((userData, index) => {
          return (
            <li className="grid grid-cols-2 gap-2 p-3 px-5" key={`${index}_`}>
              {
                userData[0] !== 'tableData' && (
                  <>
                    <label className="text-secondary font-medium">{userData[0]}</label>
                    <span className="text-placeholder">{userData[1]}</span>
                  </>
                )
              }
            </li>
          )
        })
      }
    </>
  )
}
